app.service("PaymentTransactionsAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		const baseUri = ENV.API + "/api/payment-transactions";

		/**
		 * Generates the common headers required for API authentication.
		 * @returns {Object} The headers object.
		 */
		const getHeaders = function () {
			return {
				Authorization: "Bearer " + Session.token,
				"X-PRACTICE-ID": `${Session.practice.id}`,
			};
		};

		var service = {
			isProcessing: false,

			// =================================================================
			// Card Setup & Management
			// =================================================================

			/**
			 * Initiates the "Add Card" flow by requesting a SetupIntent client secret.
			 * @param {integer} practiceId - The unique identifier of the practice.
			 */
			initiateCardSetup: function (practiceId) {
				return $http({
					method: "POST",
					url: `${baseUri}/card/initiate`,
					headers: getHeaders(),
					data: {
						practiceId: practiceId
					},
				});
			},

			/**
			 * Removes the current default payment method for the practice.
			 * @param {integer} practiceId - The unique identifier of the practice.
			 */
			deletePaymentMethod: function (paymentMethodId) {
				return $http({
					method: "DELETE",
					url: `${baseUri}/card/` + encodeURIComponent(paymentMethodId),
					headers: getHeaders(),
				});
			},

			/**
			 * Explicitly sets a payment method as the default for the practice.
			 */
			setDefaultPaymentMethod: function (paymentMethodId) {
				return $http({
					method: "POST",
					url: `${baseUri}/card/default?paymentMethodId=` + encodeURIComponent(paymentMethodId),
					headers: getHeaders(),
				});
			},

			/**
			 * Explicitly sets a backup payment method for the practice.
			 */
			setBackupPaymentMethod: function (backupPaymentMethodId) {
				return $http({
					method: "POST",
					url: `${baseUri}/card/backup?backupPaymentMethodId=` + encodeURIComponent(backupPaymentMethodId),
					headers: getHeaders(),
				});
			},

			// =================================================================
			// Wallet & Configuration
			// =================================================================

			/**
			 * Retrieves the current wallet status (balance, settings, card info).
			 */
			getWalletStatus: function () {
				return $http({
					method: "GET",
					url: `${baseUri}/wallet`,
					headers: getHeaders(),
				});
			},

			/**
			 * Updates the wallet configuration (auto-reload thresholds, amounts).
			 * @param {Object} data - The settings object { auto_reload_enabled, reload_threshold, reload_amount }
			 */
			updateWalletSettings: function (data) {
				return $http({
					method: "PUT",
					url: `${baseUri}/wallet`,
					headers: getHeaders(),
					data: data,
				});
			},

			// =================================================================
			// Trasactions and Usage
			// =================================================================

			/**
			 * Retrieves the history of transactions for logged-in practice.
			 */
			getPaymentTransactions: function (startDateUtc, endDateUtc) {
				return $http({
					method: "GET",
					url: `${baseUri}/transactions?startDateUtc=${encodeURIComponent(startDateUtc)}&endDateUtc=${encodeURIComponent(endDateUtc)}`,

					headers: getHeaders(),
				});
			},

			/**
			 * Manually initiates a top up to the auto reload amount.
			 */
			topupPracticeBalance: function () {
				return $http({
					method: "POST",
					url: `${baseUri}/topup`,

					headers: getHeaders(),
				});
			},
		};

		return service;
	},
]);